export default "__VITE_ASSET__7xkHBux9__"